import { connect } from "react-redux";
import ActiveFilterPanel from "components/molecules/ActiveFilterPanel";
import { APP_FILTER_TYPES } from "constants/filter";
import { filterChange, filterReset } from "actions";
import { getDataPointForFilter } from "utils/filter";

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, _ownProps) => {
  const filters = state.filters;
  return {
    filters:
      filters &&
      Object.keys(filters).reduce((result, filterKey) => {
        const filter = filters[filterKey];

        if (
          filter.filterType &&
          filter.filterType !== APP_FILTER_TYPES.QUERY &&
          filter.isMounted &&
          filter.values &&
          filter.values.length
        ) {
          result.push({
            name: filterKey,
            filterType: filter.filterType,
            values: filter.values.map((value) => {
              const completeFilterValueData = getDataPointForFilter(
                value,
                filter,
              );
              return {
                value: completeFilterValueData
                  ? completeFilterValueData.value
                  : value,
                label: completeFilterValueData
                  ? completeFilterValueData.label
                  : value,
              };
            }),
          });
        }
        return result;
      }, []),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFilterReset: () => {
      dispatch(filterReset());
    },
    onFilterChange: (name, values) => {
      values = values ? values : [];

      dispatch(filterChange(name, values));
    },
  };
};

const ActiveFilterPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActiveFilterPanel);

export default ActiveFilterPanelContainer;
